import { Component, OnInit, ViewContainerRef } from '@angular/core';

import { SimpleNotificationsComponent } from 'angular2-notifications';

import { NotificationService } from '../../../services/notification.service';
import { DomainService } from '../../../services/domain.service';

@Component({
    selector: 'itpx-footer',
    templateUrl: './footer.component.html',
    styleUrls: [ './footer.component.css' ]
})
export class FooterComponent implements OnInit {

     private domain;

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    constructor(
        private domainService: DomainService,
        private viewContainerRef: ViewContainerRef,
        private notificationService: NotificationService
    ) {}

    ngOnInit() {
        this.notificationService.setViewContainerRef(this.viewContainerRef);
        this.domain = this.domainService.getDomain();
    }

    onCreate(event: any) {
        console.log(event);
    }

    onDestroy(event: any) {
        console.log(event);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/partials/footer/footer.component.ts